import { render } from "./Tooltip.vue?vue&type=template&id=656cf1ec&scoped=true&bindings={}"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=656cf1ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-656cf1ec"

export default script